import React, { useState } from "react";
import { ArrowUpRight, ClipboardList, LayoutGrid } from "lucide-react";
import TnaQuiz from "./TnaQuiz";
import ProgramsCatalog from "./ProgramsCatalog";

export const CorporateSolutions = () => {
  const [tnaOpen, setTnaOpen] = useState(false);
  const [programsOpen, setProgramsOpen] = useState(false);

  return (
    <section
      id="corporate"
      data-testid="corporate-section"
      className="border-b border-black/10 bg-black text-white relative overflow-hidden"
    >
      <div className="absolute -top-24 -right-24 w-96 h-96 bg-[color:var(--bts-yellow)] opacity-10 rotate-12 pointer-events-none" />
      <div className="mx-auto max-w-7xl px-5 md:px-10 py-20 md:py-28 relative">
        <div className="max-w-3xl">
          <div className="overline text-white/60 mb-3">
            For corporates & educational institutes
          </div>
          <h2 className="font-display text-4xl md:text-5xl lg:text-6xl leading-[0.98]">
            Not sure where to
            <br />
            <span className="bg-[color:var(--bts-yellow)] text-black px-2 border border-[color:var(--bts-yellow)]">
              start
            </span>
            ? We&apos;ll help.
          </h2>
          <p className="mt-6 text-white/70 max-w-xl">
            Take a quick assessment and we&apos;ll recommend the right program —
            or skip the quiz and pick a program directly from our catalogue.
          </p>
        </div>

        <div className="mt-12 grid grid-cols-1 md:grid-cols-2 gap-0 border border-[color:var(--bts-yellow)]">
          <button
            type="button"
            onClick={() => setTnaOpen(true)}
            data-testid="corporate-cta-tna"
            className="group text-left p-8 md:p-10 flex flex-col justify-between gap-8 bg-black hover:bg-[color:var(--bts-yellow)] hover:text-black transition-colors md:border-r border-[color:var(--bts-yellow)]"
            style={{ minHeight: 320 }}
          >
            <div>
              <div className="w-12 h-12 border border-current flex items-center justify-center">
                <ClipboardList size={22} />
              </div>
              <h3 className="font-display text-2xl md:text-3xl mt-6 leading-tight">
                Business Training Needs Assessment
              </h3>
              <p className="mt-3 text-sm md:text-base opacity-80 max-w-md">
                A 7-section survey covering company, challenges, programs,
                format, outcomes, priority and a complimentary 30-minute
                consultation option.
              </p>
            </div>
            <div className="flex items-center gap-2 text-sm font-semibold">
              Start assessment
              <ArrowUpRight
                size={16}
                className="transition-transform group-hover:translate-x-1 group-hover:-translate-y-1"
              />
            </div>
          </button>

          <button
            type="button"
            onClick={() => setProgramsOpen(true)}
            data-testid="corporate-cta-programs"
            className="group text-left p-8 md:p-10 flex flex-col justify-between gap-8 bg-black hover:bg-[color:var(--bts-yellow)] hover:text-black transition-colors"
            style={{ minHeight: 320 }}
          >
            <div>
              <div className="w-12 h-12 border border-current flex items-center justify-center">
                <LayoutGrid size={22} />
              </div>
              <h3 className="font-display text-2xl md:text-3xl mt-6 leading-tight">
                Browse Workshops
              </h3>
              <p className="mt-3 text-sm md:text-base opacity-80 max-w-md">
                60+ workshops for corporates, schools and colleges — including
                Leadership, Communication, POSH, Sales and Faculty Development
                programs for teachers.
              </p>
            </div>
            <div className="flex items-center gap-2 text-sm font-semibold">
              See catalogue
              <ArrowUpRight
                size={16}
                className="transition-transform group-hover:translate-x-1 group-hover:-translate-y-1"
              />
            </div>
          </button>
        </div>
      </div>

      <TnaQuiz open={tnaOpen} onOpenChange={setTnaOpen} />
      <ProgramsCatalog open={programsOpen} onOpenChange={setProgramsOpen} />
    </section>
  );
};

export default CorporateSolutions;
